export default __webpack_public_path__ + "static/media/articles.fbc5f14b.png";